module.exports = __webpack_public_path__ + "static/china-4f0b5c6595cf49f1bc2bb0fab517892a.svg";